import { useEffect, useState } from "react";
import {
  getRulesApi,
  createRuleApi,
  updateRuleApi,
  getRuleUsersApi,
  toggleRuleApi,
  pauseUserApi,
  resumeUserApi,
  handleUserChangesApi,
  getRuleLogsApi,
} from "../apiServices/automationRule.services";

const useAutomationRules = (params = {}) => {
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ruleUsers, setRuleUsers] = useState([]);
  const [pagination, setPagination] = useState({});
  const [logs, setLogs] = useState([]);
  const [logsPagination, setLogsPagination] = useState({});

  const fetchRules = async () => {
    try {
      setLoading(true);
      const res = await getRulesApi(params);
      setRules(res?.data || []);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchRuleUsers = async () => {
    try {
      setLoading(true);
      const res = await getRuleUsersApi(params);
      setRuleUsers(res?.data?.data?.records || []);
      setPagination(res?.data?.data?.pagination || {});
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchRuleLogs = async (ruleId, logParams = {}) => {
    try {
      const res = await getRuleLogsApi(ruleId, logParams);
      setLogs(res?.data?.records || []);
      setLogsPagination(res?.data?.pagination || {});
      return res?.data;
    } catch (err) {
      console.log(err);
    }
  };

  const createRule = async (data) => {
    await createRuleApi(data);
    fetchRules();
  };

  const updateRule = async (id, data) => {
    await updateRuleApi(id, data);
    fetchRules();
  };

  const toggleRule = async (id) => {
    await toggleRuleApi(id);
    fetchRules();
  };

  const pauseUser = async (ruleId, data) => {
    const res = await pauseUserApi(ruleId, data);
    fetchRules();
    return res;
  };

  const resumeUser = async (ruleId, data) => {
    const res = await resumeUserApi(ruleId, data);
    fetchRules();
    return res;
  };

  const handleUserChanges = async (ruleId, data) => {
    const res = await handleUserChangesApi(ruleId, data);
    fetchRules();
    return res;
  };

  useEffect(() => {
    fetchRules();
  }, [JSON.stringify(params)]);

  return {
    rules,
    loading,
    fetchRules,
    createRule,
    fetchRuleUsers,
    updateRule,
    pagination,
    ruleUsers,
    toggleRule,
    pauseUser,
    resumeUser,
    handleUserChanges,
    fetchRuleLogs,
    logs,
    logsPagination,
  };
};

export default useAutomationRules;